/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Event,
  Event$inboundSchema,
  Event$Outbound,
  Event$outboundSchema,
} from "./event.js";
import {
  SeekPagination,
  SeekPagination$inboundSchema,
  SeekPagination$Outbound,
  SeekPagination$outboundSchema,
} from "./seekpagination.js";

/**
 * Paginated list of events.
 */
export type EventPaginatedResult = {
  /**
   * Array of event objects.
   */
  models?: Array<Event> | undefined;
  /**
   * Cursor-based pagination metadata for list responses.
   */
  pagination?: SeekPagination | undefined;
};

/** @internal */
export const EventPaginatedResult$inboundSchema: z.ZodType<
  EventPaginatedResult,
  z.ZodTypeDef,
  unknown
> = z.object({
  models: z.array(Event$inboundSchema).optional(),
  pagination: SeekPagination$inboundSchema.optional(),
});
/** @internal */
export type EventPaginatedResult$Outbound = {
  models?: Array<Event$Outbound> | undefined;
  pagination?: SeekPagination$Outbound | undefined;
};

/** @internal */
export const EventPaginatedResult$outboundSchema: z.ZodType<
  EventPaginatedResult$Outbound,
  z.ZodTypeDef,
  EventPaginatedResult
> = z.object({
  models: z.array(Event$outboundSchema).optional(),
  pagination: SeekPagination$outboundSchema.optional(),
});

export function eventPaginatedResultToJSON(
  eventPaginatedResult: EventPaginatedResult,
): string {
  return JSON.stringify(
    EventPaginatedResult$outboundSchema.parse(eventPaginatedResult),
  );
}
export function eventPaginatedResultFromJSON(
  jsonString: string,
): SafeParseResult<EventPaginatedResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EventPaginatedResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EventPaginatedResult' from JSON`,
  );
}
